/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  ACCOUNT_NAVIGATION,
  ROUTES,
  notification,
} from '../../../assets/constants/strings';
import SettingsTitle from '../SettingsTitle';
import Loader from '../../Loader';
import $ from 'jquery';
import CancelSubscription from '../../Modals/CancelSubscription';
import CancelSubscriptionReason from '../../Modals/CancelSubscription/CancelReason';
import { sendCancelReason } from '../../../services/axios';
import { MEMBERSHIP_INFO } from '../../../assets/constants/PaddleStrings';
import {
  CancelUserSubscription,
  CleanUpdateSubscription,
  SetUpdateSubscription,
  UpdatePaymentMethod,
  GetPaddleUserTransactions,
} from '../../../store/Paddle/paddleActions';
import { UpdateClientSubscription } from '../../../store/User/userActions';
import moment from 'moment';
import { usePaddle } from '../../../hooks/usePaddle';

const MembershipInfo = ({
  user,
  paddleLoading,
  CancelUserSubscription,
  SetUpdateSubscription,
  CleanUpdateSubscription,
  paymentMethod,
  UpdatePaymentMethod,
  GetPaddleUserTransactions,
  UpdateClientSubscription,
}) => {
  const eventCallbackFunction = (data) => {
    // console.log(data);
    if (data.name === 'checkout.completed') {
      notification('success', 'Payment method updated.');
      GetPaddleUserTransactions(user.customerPaddleId, false);
    }
  };

  const { openCheckout } = usePaddle(eventCallbackFunction, false, false);

  useEffect(() => {
    CleanUpdateSubscription();
  }, []);

  const handleCancelModal = async () => {
    $('#cancelModal').modal('hide');

    const res = await CancelUserSubscription(user.customerPaddleSubsId);

    if (res && res.success === true) {
      const today = new Date();
      const endDate = moment(today).add(1, 'month');
      const data = {
        clientId: user.userClient.id,
        paddlePlanType: 'FREE',
        paddleCustomerId: '',
        paddleSubscriptionId: '',
        paddlePriceId: '',
        startDate: new Date().toISOString(),
        endDate: new Date(endDate).toISOString(),
        planId: user.userPlans.filter((plan) => plan.name === 'Free')[0].id,
        userId: user.userID,
      };
      // console.log('data', data);

      const userRes = await UpdateClientSubscription(data);
      if (userRes && userRes.success) {
        notification('success', 'Subscription canceled succesfully.');
      } else
        notification(
          'error',
          'Subscription not canceled. Pleae try again later'
        );
    }
  };

  const handleSubmitReason = (reason, text) => {
    sendCancelReason({
      reason: reason,
      message: text.length > 0 ? text : null,
    });
    $('#cancelReasonModal').modal('hide');
  };

  const updatePayment = async () => {
    const res = await UpdatePaymentMethod(user.userPlan.subscriptionID);

    if (res && res.id) {
      openCheckout([], res.id);
    }
  };

  return (
    <div id='membership' className='membership-frame'>
      <SettingsTitle title={ACCOUNT_NAVIGATION.MEMBERSHIP.TITLE} />
      {!paddleLoading ? (
        <div className='membership-info'>
          {MEMBERSHIP_INFO(user, paymentMethod, updatePayment).map(
            (item, i) =>
              item !== null && (
                <div key={i} className='membership-info__row'>
                  <label>{item.TEXT}</label>
                  <span className='membership-info__row__value'>
                    {item.VALUE}
                  </span>
                </div>
              )
          )}
          <div className='membership-info__row__buttons mt-4'>
            <Link
              onClick={() => SetUpdateSubscription()}
              className='my-account-btn'
              to={ROUTES.UPGRADE}
            >
              Update Subscription
            </Link>
            {user.userPlan.subscriptionName !== 'Free' ? (
              <button
                className='my-account-btn secondary'
                type='button'
                onClick={() => $('#cancelModal').modal('show')}
              >
                Cancel Subscription
              </button>
            ) : null}
          </div>

          <CancelSubscription
            handleConfirm={handleCancelModal}
            isReactivate={user.userPlan.canceled}
          />
        </div>
      ) : (
        <div className='inner-load'>
          <Loader />
        </div>
      )}

      <CancelSubscriptionReason handleCancel={handleSubmitReason} />
    </div>
  );
};

const mapDispatchToProps = {
  CancelUserSubscription,
  SetUpdateSubscription,
  CleanUpdateSubscription,
  UpdatePaymentMethod,
  GetPaddleUserTransactions,
  UpdateClientSubscription,
};

export default connect(null, mapDispatchToProps)(MembershipInfo);
